export default __webpack_public_path__ + "static/media/home.f6515b27.svg";